import { useTranslation } from 'react-i18next';

import { useVersionUpdate } from '../features/version/core/VersionUpdateContext';
import { reloadPage } from '../features/version/core/reloadPage';

/* A bar under the topbar once the server serves a newer release.
   "Später" only hides it — the marker next to the footer version
   brings it back, so the hint is never lost for good. */
export function UpdateNotice() {
  const { t } = useTranslation();
  const { updateAvailable, dismissed, dismiss } = useVersionUpdate();

  if (!updateAvailable || dismissed) return null;

  return (
    <div className="update-notice" role="status">
      <span className="update-notice-message">{t('version.available')}</span>
      <span className="update-notice-actions">
        <button className="update-notice-later" onClick={dismiss}>
          {t('version.later')}
        </button>
        <button className="update-notice-reload" onClick={reloadPage}>
          {t('version.reloadNow')}
        </button>
      </span>
    </div>
  );
}
